import { NgModule } from "@angular/core";
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { CommonModule, DatePipe } from '@angular/common'; 
import { AppComponent } from "./app.component";
import { HomeComponent } from './home/home.component';
import { WelcomeComponent } from "./welcome/welcome.component";
import { DetailsComponent } from "./details/details.component";
import { ThankyouComponent } from "./thankyou/thankyou.component";
import { AppRoutingModule } from "./app.routing.module";
import {PagenotfoundComponent} from './pagenotfound/pagenotfound.component';
import { BillingComponent } from "./billing/billing.component";
import { PaymentComponent } from "./payment/payment.component";
import { SuccessComponent } from "./success/success.component";
import { FormsModule } from "@angular/forms";
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core'; // Required for the datepicker to work correctly
import { MAT_DATE_LOCALE } from '@angular/material/core';

@NgModule({ declarations: [AppComponent, HomeComponent, WelcomeComponent, DetailsComponent, ThankyouComponent, BillingComponent, PaymentComponent, SuccessComponent, PagenotfoundComponent],
    bootstrap: [AppComponent], imports: [BrowserModule, CommonModule, FormsModule, AppRoutingModule, MatDatepickerModule, MatInputModule, MatFormFieldModule, MatNativeDateModule], providers: [
        DatePipe,
        provideAnimationsAsync(),
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ] })
export class AppModule{}